/**
 * Scroll Reveal — Horizon Pro
 * IntersectionObserver-based scroll reveal for sections.
 * Adds .hp-revealed class on intersection with configurable stagger.
 * Reads settings from body data attributes.
 * Respects prefers-reduced-motion.
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const stagger = parseInt(document.body.dataset.scrollStagger || '80', 10);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        const parent = el.closest('.section') || el.parentElement;
        if (!parent) {
          el.classList.add('hp-revealed');
          observer.unobserve(el);
          return;
        }

        // Calculate stagger index among siblings
        const siblings = Array.from(parent.children);
        const index = siblings.indexOf(el);
        const delay = index * stagger;

        setTimeout(() => {
          el.classList.add('hp-revealed');
        }, delay);

        observer.unobserve(el);
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    }
  );

  function observeElements(root) {
    root.querySelectorAll('.section > *:not(.hp-revealed)').forEach((el) => {
      observer.observe(el);
    });
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeElements(document));
  } else {
    observeElements(document);
  }

  // Watch for dynamically added sections
  const mutationObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('section')) {
          Array.from(node.children).forEach((child) => observer.observe(child));
        }
        if (node.querySelectorAll) {
          observeElements(node);
        }
      }
    }
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
})();
